import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/api/core/auth/auth.service';
import { CoreService } from 'src/app/api/core/core/core.service';
import { DocketService } from 'src/app/api/core/docket/docket.service';
import { AppConfigService } from 'src/app/api/core/settings/app-config.service';
import { SettingsService } from 'src/app/api/core/settings/settings.service';
import { AlertQueueService } from 'src/app/api/utils/prompt-queue/alert-queue.service';
import { WatcherService } from 'src/app/api/utils/watcher/watcher.service';

import cloneDeep from 'lodash/cloneDeep';
import forOwn from 'lodash/forOwn';
import has from 'lodash/has';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hub-app-settings',
  templateUrl: './app-settings.component.html',
  styleUrls: ['./app-settings.component.scss'],
})
export class AppSettingsComponent implements OnInit {
  public cloneSetting: any;
  public build: string = 'production';

  public preferenceChangeCount: any = {
    printer: 0,
    general: 0,
    global: 0,
  };

  constructor(
    public settings: SettingsService,
    public alertCtrl: AlertController,
    public alertQueue: AlertQueueService,
    public modalCtrl: ModalController,
    public authService: AuthService,
    public core: CoreService,
    public config: AppConfigService,
    public watcher: WatcherService,
    public docket: DocketService,
  ) {}

  ngOnInit() {
    this.cloneSetting = cloneDeep(this.settings.getAllConfig());

    this.preferenceChangeCount = {};
    forOwn(this.cloneSetting, (value, index) => {
      this.preferenceChangeCount[index] = 0;
    });

    this.build = environment.target_build;
  }

  changeSetting(module: string, key: string, value: any): void {
    if (this.cloneSetting[module] && has(this.cloneSetting[module], key)) {
      this.cloneSetting[module][key] = value;

      // if general - check if it is a plugin change
    }

    // check difference made
    this.countChanges();
  }

  countChanges(): void {
    forOwn(this.preferenceChangeCount, (value, module) => {
      this.preferenceChangeCount[module] = 0;

      forOwn(this.cloneSetting[module], (val, prop) => {
        const savedVal: any = this.settings.getBumpScreenSettingByKey(module, prop);
        if (savedVal != val) {
          this.preferenceChangeCount[module]++;
        }
      });
    });
  }

  async save() {
    forOwn(this.cloneSetting, (moduleObj, module) => {
      forOwn(moduleObj, (value, index) => {
        this.settings.setBumpScreenSettingByKey(module, index, value);
      });
    });

    await this.settings.saveSettings(this.authService.Active_bump_screen.id);

    let alert = await this.alertCtrl.create({
      message: 'Applying changes. Please wait...',
      backdropDismiss: false,
    });

    this.alertQueue.queueAlert(alert);

    setTimeout(() => {
      alert.dismiss();
      this.modalCtrl.dismiss();
    }, 1000);
  }

  async close() {
    // check if there are unsaved changes
    let unsaved: boolean = false;
    forOwn(this.preferenceChangeCount, (value, index) => {
      unsaved = unsaved || value > 0;
    });

    if (unsaved) {
      const alertPrompt = await this.alertCtrl.create({
        message: 'You have unsaved changes. Are you sure you want to continue?',
        buttons: [
          {
            text: 'No',
          },
          {
            text: 'Yes',
            handler: () => {
              this.modalCtrl.dismiss();
            },
          },
        ],
      });

      this.alertQueue.queueAlert(alertPrompt);
    } else {
      this.modalCtrl.dismiss();
    }
  }

  contactSupport() {
    this.modalCtrl.dismiss({
      support: true,
    });
  }
}
